import { Box, Typography, Card, CardMedia, CardContent, Button } from "@mui/material";
import { FavoriteBorder, Visibility } from "@mui/icons-material";
import { useState } from "react";

const sampleVideos = [
  { id: 1, title: "🔥 Incredible Dance Moves!", views: 1023, likes: 230, thumbnail: "https://source.unsplash.com/400x250/?dance" },
  { id: 2, title: "🎤 Stunning Singing Performance", views: 2100, likes: 450, thumbnail: "https://source.unsplash.com/400x250/?music" },
  { id: 3, title: "🎭 Amazing Acting Skills", views: 3050, likes: 520, thumbnail: "https://source.unsplash.com/400x250/?actor" },
  { id: 4, title: "🤹 Jaw-Dropping Juggling Tricks", views: 1500, likes: 310, thumbnail: "https://source.unsplash.com/400x250/?circus" },
];

const DiscoverTalents = () => {
  const [likedVideos, setLikedVideos] = useState({});

  const handleLike = (id) => {
    setLikedVideos((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <Box 
      sx={{
        padding: "20px",
        marginLeft: "220px", // ✅ Adjust for left sidebar width
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
        gap: "20px",
      }}
    >
      {sampleVideos.map((video) => (
        <Card key={video.id} sx={{ borderRadius: "12px", transition: "0.3s", "&:hover": { transform: "scale(1.02)" } }}>
          <CardMedia component="img" height="200" image={video.thumbnail} alt={video.title} />
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
              {video.title}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
              <Typography sx={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "14px" }}>
                <Visibility fontSize="small" /> {video.views} Views
              </Typography>
              <Button onClick={() => handleLike(video.id)} size="small" sx={{ color: likedVideos[video.id] ? "red" : "gray" }}>
                <FavoriteBorder /> {video.likes + (likedVideos[video.id] ? 1 : 0)}
              </Button>
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default DiscoverTalents;
